import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import { LayoutModule } from '@angular/cdk/layout';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_DATE_LOCALE,MatRippleModule } from '@angular/material/core'
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { DatePipe } from '@angular/common';
import {DevicePipeGlobal} from '../app/shared/device.pipe'


import { SidenavComponent } from './sidenav/sidenav.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { LoginComponent } from './components/login/login.component';
import { PasswordComponent } from './components/password/password.component';
import { OtpComponent } from './components/otp/otp.component';
import { SetPasswordComponent } from './components/setPassword/setPassword.component';
import { CancelPatientsComponent } from './dialog/cancelPatientsReg/cancelPatients.component';
import {LogoutConfirmComponent} from './dialog/logoutConfirm/logoutConfirm.component';
import { ChangePasswordComponent } from './dialog/changePassword/changePassword.component';


import { NgxSpinnerModule } from "ngx-spinner";
import { NgxOtpInputModule } from "ngx-otp-input";
import { IssueDeviceComponent } from './dialog/issue-device/issue-device.component';
import { RemoveDeviceComponent } from './dialog/remove-device/remove-device.component';
import { RemoveFileComponent } from './dialog/remove-file/remove-file.component';
import { ViewDeviceComponent } from './dialog/view-device/view-device.component';
import {RecommendRemoveDeviceComponent} from './dialog/recommendation-device-remove/recommend-device.component'
import { AddUserComponent } from './dialog/add-user/add-user.component';
import { DeactiveUserComponent } from './dialog/deactive-user/deactive-user.component';
import { TrimOnBlurModule } from './directives/trim-on-blur/trim-on-blur.module';


@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    ToolbarComponent,
    LoginComponent,
    PasswordComponent,
    OtpComponent,
    SetPasswordComponent,
    CancelPatientsComponent,
    LogoutConfirmComponent,
    ChangePasswordComponent,
    IssueDeviceComponent,
    RemoveDeviceComponent,
    ViewDeviceComponent,
    RecommendRemoveDeviceComponent,
    AddUserComponent,
    DeactiveUserComponent,
    DevicePipeGlobal,
    RemoveFileComponent
    ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    LayoutModule,
    MatListModule,
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,  
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatMenuModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatSelectModule,
    MatRadioModule,
    MatRippleModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    ClipboardModule,
    NgxOtpInputModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    TrimOnBlurModule
  ],
  providers: [ { provide: MAT_DATE_LOCALE, useValue: 'en-GB'},DatePipe],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
